import { fields } from "@monorepo/utils/src/variables/projectsData/fundListReport/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.FILTER_FUND]: {},
});
